module.exports = __webpack_public_path__ + "static/media/Mastercard-logo.ae2ef4f7.png";